import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { ProductRepository } from "../../../../data/repository/product/ProductRepository";
import { Category } from "../../../model/Category";
import { Product } from "../../../model/Product";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetProductUseCase {
  invoke: (id: string) => Promise<ResponseState<Product>>;
}

export class GetProductUseCaseImpl implements GetProductUseCase {
  private repo: ProductRepository;

  constructor(repo: ProductRepository) {
    this.repo = repo;
  }

  async invoke(id: string): Promise<ResponseState<Category>> {
    try {
      let response = await this.repo.get(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
